var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{attrs:{"role":"presentation"}},[_c('button',{staticClass:"unstyled-button context-menu-option",class:{
      'hoverable-item': !_vm.disabled,
      'disabled-item': _vm.disabled,
      'active-descendant': _setup.active_descendent_id === _setup.id,
    },attrs:{"id":_setup.id,"role":"menuitem","tabindex":"-1","type":"button","disabled":_vm.disabled},on:{"click":function($event){return _setup.emit('click')}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }